import { useEffect, useState } from "react";
import { searchArtists } from "../services/api";
import type { ArtistSearchResult } from "../types";
import { useDebounce } from "./useDebounce";

export function useArtistAutocomplete(query: string) {
  const debounced = useDebounce(query, 250);
  const [results, setResults] = useState<ArtistSearchResult[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!debounced || debounced.length < 2) {
      setResults([]);
      return;
    }

    let cancelled = false;
    setLoading(true);
    searchArtists(debounced)
      .then((res) => {
        if (!cancelled) setResults(res.artists);
      })
      .catch(() => {
        if (!cancelled) setResults([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [debounced]);

  return { results, loading };
}
